export default __webpack_public_path__ + "static/media/notFound.1aacbd74.gif";